import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Toggle, Icon } from '@ui-kitten/components';
import { StyleSheet , TouchableOpacity } from 'react-native';
import * as RootNavigation from '../../../root.navigation.js';
import { ThemeContext } from '../../../theme-context';


const NightIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='moon'/>
);
const EditIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='edit-2'/>
);

const PeopleIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='people-outline'/>
);

const DoneIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='checkmark-square-2'/>
);
const BriefcaseIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='briefcase'/>
);
const TextIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='file-text'/>
);

const CardIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='credit-card'/>
);
export const Settings = () => {
  const [checked, setChecked] = React.useState(false);
  const themeContext = React.useContext(ThemeContext);



  const onCheckedChange = (isChecked) => {
    themeContext.toggleTheme();
    setChecked(isChecked);

  };

  return (
    <Layout
    style={styles.item}
    >
      <Layout style={{flexDirection:'row', justifyContent:'space-between', marginRight:20}} >
        <Layout style={styles.contentContainer}>
          <NightIcon />
          <Text style={styles.text}>حالت شب</Text>
        </Layout>
        <Toggle checked={checked} onChange={onCheckedChange} />
      </Layout>
      <Divider />
      <TouchableOpacity onPress={()=>{RootNavigation.navigate('EditProfile')}}>
      <Layout style={styles.contentContainer}>
        <EditIcon />
        <Text style={styles.text}>ویرایش حساب کاربری</Text>
      </Layout>
      </TouchableOpacity>
      <Divider />

      <TouchableOpacity onPress={()=>{RootNavigation.navigate('Supervisor')}}>
      <Layout style={styles.contentContainer}>
        <PeopleIcon />
        <Text style={styles.text}>شبکه همکاران</Text>
      </Layout>
      </TouchableOpacity>
      <Divider />

      <TouchableOpacity onPress={()=>{RootNavigation.navigate('CompletedTasks')}}>
      <Layout style={styles.contentContainer}>
        <DoneIcon />
        <Text style={styles.text}>کارهای تکمیل شده</Text>
      </Layout>
      </TouchableOpacity>
      <Divider />

      <TouchableOpacity onPress={()=>{RootNavigation.navigate('OpenTasks')}}>
      <Layout style={styles.contentContainer}>
        <BriefcaseIcon />
        <Text style={styles.text}>کارهای در جریان تکنسین</Text>
      </Layout>
      </TouchableOpacity>
      <Divider />

      <TouchableOpacity onPress={()=>{RootNavigation.navigate('AddressHistory')}}>
      <Layout style={styles.contentContainer}>
        <TextIcon />
        <Text style={styles.text}>آدرس های ثبت شده توسط تکنسین</Text>
      </Layout>
      </TouchableOpacity>

      <TouchableOpacity onPress={()=>{RootNavigation.navigate('PaymentList')}}>
      <Layout style={styles.contentContainer}>
        <CardIcon />
        <Text style={styles.text}>پرداختی های شرکت</Text>
      </Layout>
      </TouchableOpacity>

    </Layout>
  );
};


const styles = StyleSheet.create({

  contentContainer: {
  flexDirection:'row' ,
  alignItems:'center',
  paddingVertical:12,

  },
  item: {
    marginTop: 10,
    paddingHorizontal:6

  },
  text:{
    marginHorizontal:10
  }
});
